// extracted by mini-css-extract-plugin
export var tags = "tags-module--tags--2wL7i";
export var tag = "tags-module--tag--M0Z3k";